export const CLABE = 'clabe';

export const addDaysToDate = (startDateString: string | undefined, daysToAdd: number): string => {
  if (!startDateString) {
    return new Date().toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }

  const startDate = new Date(startDateString);
  const result = new Date(startDate);

  // Calculamos los fines de semana que hay en el rango
  const weekends = Math.floor(daysToAdd / 5) * 2;
  // Ajustamos los días restantes si caen en fin de semana
  const remainingDays = daysToAdd % 5;
  const finalDay = result.getDay();
  const extraWeekendDays = finalDay + remainingDays > 5 ? 2 : 0;

  result.setDate(result.getDate() + daysToAdd + weekends + extraWeekendDays);

  return result.toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const getResolutionDate = (daysToAdd: number, startDate?: string): number => {
  if (!startDate) return daysToAdd;
  const days = Math.max(
    Math.ceil((new Date(startDate).getTime() - Date.now()) / (1000 * 60 * 60 * 24)) + daysToAdd,
    0
  );

  return days;
};

export const getDaysInNextMonth = (date: string | undefined): number => {
  if (!date) return 30;

  const currentDate = new Date(date);
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  // Obtener el último día del mes siguiente
  const lastDay = new Date(year, month + 2, 0);
  return lastDay.getDate();
};
